import { Document } from '@contentful/rich-text-types';
import { api } from './api';

export interface IContactInfo {
  phone?: string;
  email?: string;
  openingHours?: Document | string;
}

export const contactApi = api.injectEndpoints({
  endpoints: (build) => ({
    getContactInfo: build.query<IContactInfo, void>({
      query: () => ({
        url: 'ContactInformation',
        method: 'GET',
      }),
      keepUnusedDataFor: 6000, // Cache data for 10 minutes
    }),
  }),
});

export const { useGetContactInfoQuery } = contactApi;
